import { SlotType } from '@rome/response/page/v4/SlotType';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import get from 'lodash/get';
import { pageTypes } from 'constants/pageTypes';
import * as actions from 'actions/pageActionsV4';
const { PAGE_DATA_ACTIONS } = actions;
const TAB_ID_KEY = actions.TAB_ID_KEY;
/**
 * Extract omniture Info from widgets
 */
const extractOmnitureInfo = (slots) => {
    const n = slots.length;
    const omnitureData = {};
    const omnitureEvents = [];
    for (let i = 0; i < n; i++) {
        const slot = slots[i];
        if (slot.slotType !== SlotType.WIDGET) {
            continue;
        }
        const widgetSlot = slot;
        if (!widgetSlot.widget) {
            continue;
        }
        let data = get(widgetSlot.widget, [
            'data'
        ]);
        switch (widgetSlot.widget.type) {
            case WidgetTypeV4.PINCODE_SERVICEABILITY:
                const pincodeWidget = data;
                const pincodeWidgetValue = get(pincodeWidget, [
                    'renderableComponents',
                    0
                ]);
                const prop11 = get(pincodeWidgetValue, ['value', 'pincode']) ? 'PINCODE_PRESENT' : 'PINCODE_ABSENT';
                omnitureData['prop11'] = prop11;
                break;
            case WidgetTypeV4.BROWSE_SERVICEABILITY_FILTER:
                const serviceabilityMessage = get(data, 'serviceability.tracking.PROP27', '');
                const pincode = get(data, 'pincode', '');
                omnitureData['prop58'] = serviceabilityMessage;
                omnitureData['eVar52'] = pincode;
                omnitureData['prop60'] = pincode ? 'PINCODE_PRESENT' : 'PINCODE_ABSENT';
                break;
            case WidgetTypeV4.PRODUCT_OFFERS:
                const offerGroups = get(data, 'offerGroups', []);
                if (offerGroups && offerGroups.length > 0) {
                    omnitureEvents.push('event418=1');
                }
                break;
            default:
        }
    }
    return {
        omnitureData,
        omnitureEvents
    };
};
export default function (state = {}, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
            const slots = get(action, 'data.slots');
            if (!slots)
                return state;
            const { omnitureData, omnitureEvents: extractedOmniEvents = [] } = extractOmnitureInfo(slots);
            const omnitureEvents = (state.omnitureEvents || []).concat(extractedOmniEvents || []);
            return { omnitureData, omnitureEvents };
        case PAGE_DATA_ACTIONS.REQUEST:
            const tabID = (typeof window !== 'undefined' && window[TAB_ID_KEY]) || '';
            if (!tabID && action.pageType === pageTypes.Home) {
                const omnitureEvents = [];
                // this will be send only if Home page is opened for the first time.
                // action will not have tabId variable via IExtraPageRequestOptions in first call,
                // it will be appended in first call success only, which will help in
                // discreminate that is it Fist most Home page call
                // Refresh call will not follow same scenario as reducer state will have tabId which was
                // added in very first success call.
                omnitureEvents.push('event199');
                return { omnitureEvents };
            }
            else {
                return {};
            }
        case PAGE_DATA_ACTIONS.ERROR:
        case PAGE_DATA_ACTIONS.CLEAR:
            return {};
        default:
            return state;
    }
}
